import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Contact = () => {
  return (
    <Box
      id="contact-section"
      component="section"
      sx={{
        color: 'white',
        borderRadius: 2,
        p: 4,
        mb: 15, // Added padding
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h1"
          id="Hunts"
          color="black"
          textAlign="center"
          mb={4}
        >
          Contact Us
        </Typography>
        <Grid container spacing={4} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={6}>
            <iframe
              title="Google Maps"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d735.8955440618687!2d-84.52381013203858!3d31.219909002362783!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88ed6bf5e70e4127%3A0xda150639b5a3dad8!2s4039%20Josuli%20Rd%2C%20Colquitt%2C%20GA%2039837!5e1!3m2!1sen!2sus!4v1673128681395!5m2!1sen!2sus"
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: '8px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              className="myh2"
              id="Hunts"
              color="black"
              textAlign="center"
              mb={4}
            >
              Gary Smith | Owner
            </Typography>
            <Typography variant="body1" color="black">
              4039 Josuli Rd, Colquitt, GA 39837
            </Typography>
            <Typography variant="body1" color="black" mt={1}>
              Phone:{' '}
              <a
                href="tel:+12292248494"
                style={{ color: 'orange', textDecoration: 'none' }}
              >
                (229) 224-8494
              </a>
            </Typography>
            <Typography variant="body1" color="black" mt={1}>
              Email:{' '}
              <a
                href="mailto:trophygahunts@hotmail.com"
                style={{ color: 'orange', textDecoration: 'none' }}
              >
                trophygahunts@hotmail.com
              </a>
            </Typography>
            <Box mt={2}>
              <a
                href="https://www.facebook.com/TrophyGeorgiaHunts"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'blue', textDecoration: 'none' }}
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg"
                  alt="Facebook"
                  style={{ width: '32px', height: '32px' }}
                />
              </a>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
export default Contact;
